import React, { useCallback, useState, createContext, useContext } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
interface Toast {
  id: string;
  message: string;
}
interface ToastContextType {
  addToast: (message: string, duration?: number) => void;
}
const ToastContext = createContext<ToastContextType | undefined>(undefined);
export function ToastProvider({
  children
}: {
  children: ReactNode;
}) {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const addToast = useCallback((message: string, duration = 3000) => {
    const id = Math.random().toString(36).substr(2, 9);
    setToasts(prev => [...prev, {
      id,
      message
    }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, duration);
  }, []);
  const removeToast = (id: string) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  };
  return <ToastContext.Provider value={{
    addToast
  }} data-id="element-248">
      {children}
      <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none" data-id="element-249">
        <AnimatePresence data-id="element-250">
          {toasts.map(toast => <motion.div key={toast.id} initial={{
          opacity: 0,
          y: 20,
          scale: 0.9
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.9,
          transition: {
            duration: 0.2
          }
        }} className="bg-gray-900 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 pointer-events-auto min-w-[200px]" data-id="element-251">
              <span className="text-sm font-medium" data-id="element-252">{toast.message}</span>
              <button onClick={() => removeToast(toast.id)} className="ml-auto text-gray-400 hover:text-white transition-colors" data-id="element-253">
                <X size={14} data-id="element-254" />
              </button>
            </motion.div>)}
        </AnimatePresence>
      </div>
    </ToastContext.Provider>;
}
export function useToast() {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
}